import React from "react";

export function Card({
    className = '',
    children,
    ...props
}) {
    return (
        <div className={`tw-rounded-xl tw-p-4 md:tw-p-8 ${className}`} {...props}>
            {children}
        </div>
    );
}
